import { render, staticRenderFns } from "./main-drawer.vue?vue&type=template&id=f513ee68&scoped=true"
import script from "./main-drawer.vue?vue&type=script&lang=js"
export * from "./main-drawer.vue?vue&type=script&lang=js"
import style0 from "./main-drawer.vue?vue&type=style&index=0&id=f513ee68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f513ee68",
  null
  
)

export default component.exports